<template>
  <administrators-list
    v-if="selectedDomain.id"
    :tier="tierType"
    :id="selectedDomain.id"
  />
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import AdministratorsList from "@/views/Common/Administrators/index.vue";

import { TIER } from "@/constants";

export default {
  components: {
    AdministratorsList,
  },
  data() {
    return {
      tierType: TIER.domains,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedDomain"]),
  },
  mounted() {
    this.setPageTitle(this.$t("Administrators"));
    this.setPageSubtitle([]);
  },
};
</script>
